export default __webpack_public_path__ + "static/ikm-dc709519d244c1ff60d4b6408c736b5a.webp";